import { motion } from "framer-motion";
import {
  GraduationCap,
  Music,
  Car,
  Building2,
  Church,
  Globe,
  CalendarDays,
  MapPin,
} from "lucide-react";

const services = [
  { icon: GraduationCap, title: "Escolares", desc: "Transporte seguro para instituciones educativas" },
  { icon: Music, title: "Artistas", desc: "Traslado de bandas, giras y producciones" },
  { icon: Car, title: "Transfers", desc: "Aeropuerto, terminal y hoteles" },
  { icon: Building2, title: "Corporativo", desc: "Eventos empresariales, convenciones y traslado de personal" },
  { icon: Church, title: "Peregrinaciones", desc: "Viajes religiosos con total comodidad" },
  { icon: Globe, title: "Internacional", desc: "Cruces fronterizos y circuitos regionales" },
  { icon: CalendarDays, title: "Eventos", desc: "Fiestas, casamientos y celebraciones" },
  { icon: MapPin, title: "Circuitos", desc: "Rutas turisticas y excursiones" },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function Servicios() {
  return (
    <section
      id="servicios"
      className="py-20 md:py-32 bg-[#0D1525]"
      data-testid="servicios-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <span className="text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] font-body">
            Que hacemos
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white uppercase tracking-tight mt-3">
            Nuestros Servicios
          </h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {services.map((svc, i) => {
            const Icon = svc.icon;
            return (
              <motion.div
                key={i}
                className="group relative p-6 md:p-8 bg-[#151e32] border border-white/5 hover:border-[#3DD9E8]/50 transition-all duration-300 hover:-translate-y-2"
                variants={itemVariants}
                data-testid={`service-card-${svc.title.toLowerCase()}`}
              >
                <div className="w-12 h-12 flex items-center justify-center mb-5 border border-[#3DD9E8]/30 group-hover:bg-[#3DD9E8]/10 transition-colors duration-300">
                  <Icon className="text-[#3DD9E8]" size={24} />
                </div>
                <h3 className="font-heading text-xl md:text-2xl text-white uppercase tracking-wide mb-2">
                  {svc.title}
                </h3>
                <p className="text-gray-400 font-body text-sm font-light leading-relaxed">
                  {svc.desc}
                </p>
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-0 h-0 group-hover:w-8 group-hover:h-8 border-t-2 border-r-2 border-[#D0162A] transition-all duration-300" />
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
